'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.users', {
            url: '/users',
            templateUrl: 'dashboard-users/dashboard-users.html',
            controller: 'dashboardUsersCtrl as ctrl',
            resolve: {
                clients: [
                  "Client",
                  function (Client) {
                    return Client.find({
                      filter: {
                        where:{"isOU":true},
                      },
                    }).$promise.then(function (clients) {
                      return clients;
                    });
                  },
                ],
                clientsAll: [
                    "Client",
                    function (Client) {
                      return Client.find()
                      .$promise
                      .then(function (clients) {
                        // console.log('clientsAll en config', clients);
                        return clients;
                      });
                    },
                  ],
                members: ['Member', function(Member) {
                    return Member
                        .find({
                            filter: {
                                include: ['clients','roles','company', {
                                    relation: "device",                                    
                                    scope: {
                                      fields:["id","deviceId","model","isBrowser"],
                                      where: { "isBrowser":{"neq":true}},
                                    },
                                  }]
                            },                            
                        })
                        .$promise
                        .then(function(data) {
                            return data.sort((a,b)=>(a.lastName||"").localeCompare((b.lastName||"")));
                        });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'owner']
            }
        });
};
